// extracted by mini-css-extract-plugin
export default {"root":"k9TExT","edit":"i3hGY8","label":"pfyoC4","actions":"Kqmbmc"};